import React from "react";

import type { Mandate } from "../../../../../shared/domains/mandates/mandate";
import { OPPOSE_MANDATE_MODAL_ID } from "../../../../core/modal/modal-id";
import { MandateModal } from "./mandate-modal";

export interface OpposeMandateModalProps {
  mandate: Mandate;
  onConfirm: () => void;
}

export const OpposeMandateModal = (props: OpposeMandateModalProps) => {
  const { mandate, onConfirm } = props;

  return (
    <MandateModal
      mandate={mandate}
      onConfirm={onConfirm}
      modalId={OPPOSE_MANDATE_MODAL_ID}
      textPrompt={"mandates.opposePrompt"}
    />
  );
};
